import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '../../lib/utils/cn';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  error?: boolean;
};

const Input = forwardRef<HTMLInputElement, Props>(({ className, error, ...props }, ref) => {
  return (
    <input
      ref={ref}
      className={cn(
        'w-full rounded-lg border px-4 py-2.5 focus:outline-none focus:ring-2 disabled:bg-gray-50 disabled:cursor-not-allowed',
        error
          ? 'border-red-300 focus:ring-red-500'
          : 'border-gray-300 focus:ring-green-500 focus:border-green-500',
        className
      )}
      {...props}
    />
  );
});

Input.displayName = 'Input';

export default Input;
